import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Lightbulb, MoreVertical, Settings, LogOut, MessageCircleQuestionMark } from 'lucide-react';

const MenuItem = ({ icon: Icon, label, onClick, to, danger = false }) => {
  const className =
    'flex w-full items-center gap-2.5 px-3 py-2.5 text-[14px] transition-colors hover:bg-[var(--bg-surface)]';
  const color = danger ? '#dc2626' : 'var(--text-primary)';
  const iconColor = danger ? '#dc2626' : 'var(--text-muted)';

  if (to) {
    return (
      <Link to={to} onClick={onClick} className={className} style={{ color }} role='menuitem'>
        <Icon style={{ width: '1rem', height: '1rem', color: iconColor }} />
        <span>{label}</span>
      </Link>
    );
  }
  return (
    <button type='button' onClick={onClick} className={`${className} text-left`} style={{ color }} role='menuitem'>
      <Icon style={{ width: '1rem', height: '1rem', color: iconColor }} />
      <span>{label}</span>
    </button>
  );
};

const MobileAccountMenu = ({ onLogout, onStartTour, contactSupportUrl }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);

  return (
    <div className='relative' ref={ref}>
      <button
        type='button'
        aria-label='Account menu'
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        className='flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl cursor-pointer transition-colors'
        style={{
          background: 'var(--bg-card)',
          border: '1px solid var(--border)',
          color: 'var(--text-primary)',
          boxShadow: '0 10px 30px rgba(15, 23, 42, 0.08)',
        }}
      >
        <MoreVertical style={{ width: '1.2rem', height: '1.2rem' }} />
      </button>
      {open ? (
        <div
          role='menu'
          className='absolute right-0 top-full z-50 mt-2 w-56 overflow-hidden rounded-xl py-1 shadow-xl'
          style={{ background: 'var(--bg-card)', border: '1px solid var(--border)' }}
        >
          <MenuItem
            icon={Settings}
            label='Account settings'
            to='/settings'
            onClick={() => setOpen(false)}
          />
          <MenuItem
            icon={MessageCircleQuestionMark}
            label='Contact support'
            onClick={() => {
              setOpen(false);
              if (contactSupportUrl) window.location.href = contactSupportUrl;
            }}
          />
          <div className='my-1 h-px' style={{ background: 'var(--border)' }} />
          <MenuItem
            icon={LogOut}
            label='Log out'
            danger
            onClick={() => {
              setOpen(false);
              onLogout?.();
            }}
          />
        </div>
      ) : null}
    </div>
  );
};

export default MobileAccountMenu;
